import { productsClient } from "../lib/clients";
import { alreadyVisitedPointsUpdatedListener } from "../listeners";
import { LoggerFactory } from "../utils/loggerFactory";
import LoginService from "./LoginService";
const log = LoggerFactory("DetailsService");

const api = productsClient;

const DetailsService = {
  async find(location) {
    try {
      const response = await api.get(`/details/already-visited/${location}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${LoginService.getAccessToken()}`,
        },
      });

      const { data, status } = response;

      if (status !== 200) return null;

      return data;
    } catch (error) {
      log("find").error("error trying to find details by location: {}", error);
      return null;
    }
  },

  async detailsVisited(location) {
    try {
      const response = await api.get(
        `/details/already-visited/${location}/visited`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${LoginService.getAccessToken()}`,
          },
        },
      );

      const { data, status } = response;
      if (status !== 200) return null;

      return data?.alreadyVisited;
    } catch (error) {
      log("detailsVisited").error(
        "error trying to verify if this point is already visited: {}",
        error,
      );
      return false;
    }
  },

  async updatedVisited(location, visited) {
    try {
      const response = await api.put(
        `/details/already-visited/${location}/visited/${visited}`,
        null,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${LoginService.getAccessToken()}`,
          },
        },
      );

      const { data, status } = response;
      if (status !== 200) return null;

      alreadyVisitedPointsUpdatedListener.publish({ location });

      return data;
    } catch (error) {
      log("updatedVisited").error(
        "error trying to update point visitation status: {}",
        error,
      );
      return null;
    }
  },

  async findAlreadyVisitedPoints(coordinates, filters, filtersData) {
    const selectedProvinces =
      filtersData?.dataStore?.selectedProvinces
        ?.map((province) => province.role)
        ?.join(",") ?? "";
    try {
      const request = JSON.stringify(coordinates, null, 0);

      const response = await api.get(
        `/details/already-visited?coordinates=${request}
        &filters=${encodeURIComponent(filters)}
        &provinces=${encodeURIComponent(selectedProvinces)}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${LoginService.getAccessToken()}`,
          },
        },
      );

      const { data, status } = response;
      if (status !== 200) return null;

      return data ?? null;
    } catch (error) {
      log("findAlreadyVisitedPoints").error(
        "error trying to find already visited points for coordinates: {}",
        error,
      );
      return null;
    }
  },
};

export default DetailsService;
